import {InputNumber} from "primereact/inputnumber";

const MaterialFields = ({fields, containerClassName, itemClassName}) => (
	<div className={containerClassName}>
		{fields.map(({label, value, onChange}) => (
			<div key={label} className={itemClassName}>
				<label className="text-sm mb-1.5 font-semibold block">{label}</label>
				<div className="flex items-end mt-1">
					<InputNumber
						value={value}
						onChange={(e) => onChange(e.value)}
						className="w-full !border-none"
						inputClassName="border p-2 rounded-lg border-gray-300"
						style={{
							border: "1px solid #ced4da",
							borderRadius: "0.5rem",
						}}
						onKeyDown={(e) => {
							if (e.key === "-" || e.key === ".") {
								e.preventDefault();
							}
						}}
					/>
				</div>
			</div>
		))}
	</div>
);

export default MaterialFields;
